$control-width: 50px;
$control-height: 27px;
$handle-size: 23px;
$handle-offset: 2px;

.ux-cookie-layer-switch {
    display: block;
    margin-bottom: 15px;

    &:not(:last-of-type) {
        border-bottom: 1px solid var(--ux-cookie-layer-separator-color);
    }

    &__label {
        display: inline-block;
        margin: 0;
        padding: 0 15px 0 0;
        flex: 1 1 auto;
        color: var(--ux-cookie-layer-label-color);
        font-family: var(--ux-cookie-layer-label-font);
        font-weight: var(--ux-cookie-layer-label-font-weight);
        font-size: var(--ux-cookie-layer-label-font-size);
        text-transform: var(--ux-cookie-layer-label-text-transform);
    }

    &__inner {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: stretch;
        margin-bottom: 15px;
    }

    &__button {
        background-color: var(--ux-cookie-layer-switch-off-color);
        border: 0 none transparent;
        border-radius: 0.5 * $control-height;
        cursor: pointer;
        display: inline-block;
        flex: 0 0 auto;
        height: $control-height;
        margin: 0;
        padding: 0;
        position: relative;
        transition: background-color 250ms ease;
        user-select: none;
        width: $control-width;

        &:focus-visible:not(:hover) {
            outline: var(--ux-cookie-layer-button-outline-width) solid
                var(--ux-cookie-layer-button-outline-color);
            outline-offset: var(--ux-cookie-layer-button-outline-offset);
        }
    }

    &__handle {
        background-color: var(--ux-cookie-layer-switch-handle-color, #fff);
        display: block;
        width: $handle-size;
        height: $handle-size;
        border-radius: $handle-size;
        position: absolute;
        left: $handle-offset;
        top: $handle-offset;
        transition: transform 250ms ease;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }

    &__svg {
        display: var(--ux-cookie-layer-switch-icon-display, block);
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        rect {
            display: none;
        }
    }

    &__desc {
        font-size: var(--ux-cookie-layer-font-size-small);
    }

    &--on {
        .ux-cookie-layer-switch__button {
            background-color: var(--ux-cookie-layer-switch-on-color);
        }

        .ux-cookie-layer-switch__handle {
            transform: translateX($control-width - $control-height);
        }
    }

    &--disabled {
        .ux-cookie-layer-switch__button {
            cursor: not-allowed;
        }

        .ux-cookie-layer-switch__handle {
            background-color: var(
                --ux-cookie-layer-switch-handle-disabled-color,
                #fff
            );
            pointer-events: none;
        }
    }
}
